import UI from "~/ui";
import $ from "jquery";
import { FilterElements, OriginalParent, SubCategory } from "./interfaces";

/**
 * Gestisce i filtri di ricerca (categorie, prezzo, superficie)
 */
export class SearchFilters {
    private originalParents: Record<string, OriginalParent> = {};

    /**
     * Inizializza il sistema di toggle dei filtri responsive
     */
    public initFilterToggle(): void {
        this.saveOriginalPositions();
        this.toggleFilterVisibility();
        window.addEventListener('resize', () => this.toggleFilterVisibility());
    }

    /**
     * Inizializza i pulsanti per il toggle dei filtri
     */
    public initFilterToggleButtons(): void {
        $('.filterWrapToggle').on('click', () => {
            $('.filterWrap').toggleClass('hideFilter');
            $('.resultsWrap').toggleClass('hideFilter');
            $('.filterWrapToggle').toggleClass('hideFilter');
        });
    }

    // ====== FILTRI SOTTO CATEGORIE ======

    /**
     * Inizializza la selezione delle sotto categorie
     */
    public initSelectSubCategories(): void {
        const categoryId = this.getCategoryIdAndUpdateSession();
        this.loadSelectSubCategoriesByCategoryId(categoryId);

        const categorySelect = document.getElementById('categ');
        categorySelect?.addEventListener('change', (e) => {
            const target = e.target as HTMLSelectElement;
            const newCategoryId = parseInt(target.value, 10);
            this.loadSelectSubCategoriesByCategoryId(newCategoryId);
        });
    }

    // ====== FILTRI PREZZO ======

    /**
     * Inizializza i filtri di prezzo
     */
    public initPriceFilter(): void {
        const savedMinPrice = sessionStorage.getItem('minPrice');
        const savedMaxPrice = sessionStorage.getItem('maxPrice');

        if (savedMinPrice) $("#minPrice").val(savedMinPrice);
        if (savedMaxPrice) $("#maxPrice").val(savedMaxPrice);

        $("#dropdownPrice").on('click', () => {
            $("#min-options").show();
            $("#max-options").hide();
        });

        $("#dropdPrice").on('click', (event) => {
            event.stopPropagation();
        });

        $("#minPrice").on('focus', () => {
            $("#min-options").show();
            $("#max-options").hide();
        });

        $("#maxPrice").on('focus', () => {
            $("#min-options").hide();
            $("#max-options").show();
        });

        $("#filtriRicercaPrezzo").find(".dropdown-item").on('click', function () {
            const priceText = $(this).text();
            const isMinOption = $(this).parent().attr('id') === 'min-options';

            if (isMinOption) {
                $("#minPrice").val(priceText);
                $("#min-options").hide();
                $("#max-options").show();
            } else {
                $("#maxPrice").val(priceText);
            }
        });

        $("#closeDropPrezzo").on('click', () => {
            $("#dropdownPrice").click();
        });
    }

    // ====== FILTRI SUPERFICIE ======

    /**
     * Inizializza i filtri di superficie
     */
    public initSurfaceFilter(): void {
        const savedMinSup = sessionStorage.getItem('minSup');
        const savedMaxSup = sessionStorage.getItem('maxSup');

        if (savedMinSup) $("#minSup").val(savedMinSup);
        if (savedMaxSup) $("#maxSup").val(savedMaxSup);

        $("#dropdownSup").on('click', () => {
            $("#min-optionssup").show();
            $("#max-optionssup").hide();
        });

        $("#dropdSup").on('click', (event) => {
            event.stopPropagation();
        });

        $("#minSup").on('focus', () => {
            $("#min-optionssup").show();
            $("#max-optionssup").hide();
        });

        $("#maxSup").on('focus', () => {
            $("#min-optionssup").hide();
            $("#max-optionssup").show();
        });

        $("#filtriRicercaSuperficie").find(".dropdown-item").on('click', function () {
            const surfaceText = $(this).text();
            const isMinOption = $(this).parent().attr('id') === 'min-optionssup';

            if (isMinOption) {
                $("#minSup").val(surfaceText);
                $("#min-optionssup").hide();
                $("#max-optionssup").show();
            } else {
                $("#maxSup").val(surfaceText);
            }
        });

        $("#closeDropSuperficie").on('click', () => {
            $("#dropdownSup").click();
        });
    }

    /**
     * Salva i valori dei filtri nel session storage
     */
    public saveFilterValuesToSession(): void {
        const formattedAddress = (document.getElementById('autocomplete-immobili') as HTMLInputElement)?.value;
        if (formattedAddress && formattedAddress.trim()) {
            sessionStorage.setItem('formattedAddress', formattedAddress);
        } else {
            sessionStorage.removeItem('formattedAddress');
        }

        const categorySelect = document.getElementById('categ') as HTMLSelectElement;
        if (categorySelect && categorySelect.selectedIndex >= 0) {
            const selectedCategory = categorySelect.options[categorySelect.selectedIndex].value;
            sessionStorage.setItem('selectedCategory', selectedCategory !== '0' ? selectedCategory : '');
        }

        const subCategorySelect = document.getElementById('subcateg') as HTMLSelectElement;
        if (subCategorySelect && subCategorySelect.selectedIndex >= 0) {
            const selectedSubCategory = subCategorySelect.options[subCategorySelect.selectedIndex].value;
            sessionStorage.setItem('selectedSubCategories', selectedSubCategory !== '0' ? selectedSubCategory : '');
        }

        const minPriceElement = document.getElementById('minPrice') as HTMLInputElement;
        if (minPriceElement) {
            const minPrice = minPriceElement.value;
            minPriceElement.value = this.convertStringToDecimal(minPrice).toString();
            sessionStorage.setItem('minPrice', minPrice);
        }

        const maxPriceElement = document.getElementById('maxPrice') as HTMLInputElement;
        if (maxPriceElement) {
            const maxPrice = maxPriceElement.value;
            maxPriceElement.value = this.convertStringToDecimal(maxPrice).toString();
            sessionStorage.setItem('maxPrice', maxPrice);
        }

        const minSurfaceElement = document.getElementById('minSup') as HTMLInputElement;
        if (minSurfaceElement) {
            const minSurface = minSurfaceElement.value;
            minSurfaceElement.value = this.convertSurfaceToInteger(minSurface).toString();
            sessionStorage.setItem('minSup', minSurface);
        }

        const maxSurfaceElement = document.getElementById('maxSup') as HTMLInputElement;
        if (maxSurfaceElement) {
            const maxSurface = maxSurfaceElement.value;
            maxSurfaceElement.value = this.convertSurfaceToInteger(maxSurface).toString();
            sessionStorage.setItem('maxSup', maxSurface);
        }
    }

    // ====== METODI PRIVATI ======

    private saveOriginalPositions(): void {
        const elements = this.getFilterElements();

        for (const key in elements) {
            const element = elements[key as keyof FilterElements];
            if (element && element.parentNode) {
                this.originalParents[key] = {
                    parent: element.parentNode,
                    nextSibling: element.nextSibling
                };
            }
        }
    }

    private getFilterElements(): FilterElements {
        return {
            filtrocateg: document.getElementById('filtriRicercaCategoria'),
            filtrosup: document.getElementById('filtriRicercaSuperficie'),
            filtroprez: document.getElementById('filtriRicercaPrezzo'),
            filtrodove: document.getElementById('filtriRicercaDove'),
            filtrotipo: document.getElementById('filtriRicercaTipologia'),
            btnSearch: document.getElementById('btnSearch'),
            modale: document.getElementById('modalfilterresize'),
            barra: document.getElementById('frmcerca')
        };
    }

    private toggleFilterVisibility(): void {
        const viewportWidth = window.innerWidth;
        const elements = this.getFilterElements();

        if (!elements.modale) return;

        if (viewportWidth < 1200) {
            this.moveElement(elements.filtrosup, elements.modale, 1);
            this.moveElement(elements.filtroprez, elements.modale, 1);
        } else {
            this.restoreOriginalPosition('filtrosup', elements);
            this.restoreOriginalPosition('filtroprez', elements);
            elements.modale.innerHTML = '';
        }

        if (viewportWidth < 992) {
            this.moveElement(elements.filtrotipo, elements.modale, 1);
        } else {
            this.restoreOriginalPosition('filtrotipo', elements);
        }

        if (viewportWidth < 768) {
            this.moveElement(elements.filtrocateg, elements.modale, 1);
        } else {
            this.restoreOriginalPosition('filtrocateg', elements);
        }

        if (viewportWidth < 576) {
            this.moveElement(elements.filtrodove, elements.modale, 1);
            this.moveElement(elements.btnSearch, elements.modale, 1);
        } else {
            this.restoreOriginalPosition('filtrodove', elements);
            this.restoreOriginalPosition('btnSearch', elements);
        }
    }

    private moveElement(element: HTMLElement | null, target: HTMLElement, counterValue: number): void {
        if (element && target && element.parentNode !== target) {
            element.parentNode?.removeChild(element);
            target.appendChild(element);
            this.updateCounter(counterValue);
        }
    }

    private restoreOriginalPosition(elementKey: string, elements: FilterElements): void {
        const original = this.originalParents[elementKey];
        const element = elements[elementKey as keyof FilterElements];

        if (!original || !element) return;

        if (element.parentNode !== original.parent) {
            if (original.nextSibling && original.nextSibling.parentNode === original.parent) {
                original.parent.insertBefore(element, original.nextSibling);
            } else {
                original.parent.appendChild(element);
            }
            this.updateCounter(-1);
        }
    }

    private updateCounter(value: number): void {
        const counter = document.getElementById('contaquanti');
        if (!counter) return;

        const currentValue = parseInt(counter.textContent || '0') || 0;
        const newValue = Math.max(0, currentValue + value);
        counter.textContent = newValue.toString();
    }

    private getCategoryIdAndUpdateSession(): number {
        const categorySelect = document.getElementById('categ') as HTMLSelectElement;
        const categoryId = parseInt(categorySelect.value, 10);
        this.updateSessionCategory(categoryId);
        return categoryId;
    }

    private updateSessionCategory(categoryId: number): void {
        if (categoryId > 0) {
            sessionStorage.setItem("selectedCategory", categoryId.toString());
        } else {
            sessionStorage.removeItem("selectedCategory");
        }
    }

    private async loadSelectSubCategoriesByCategoryId(categoryId: number): Promise<void> {
        if (typeof categoryId !== 'number' || isNaN(categoryId)) {
            return;
        }

        const url = window.BaseUrlWebApi + "VenditePrivate/GetSubCategories";

        try {
            const response = await fetch(`${url}?categoryId=${categoryId}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: SubCategory[] = await response.json();
            if (data && Array.isArray(data)) {
                this.populateSubCategorySelect(data);
            }
        } catch (error) {
            console.error('Errore nel recupero delle sotto categorie:', error);
            UI.confirmOneButton("", "Si è verificato un errore durante il recupero delle sotto categorie.");
        } finally {
            $("#loading2").hide();
        }
    }

    private populateSubCategorySelect(subCategories: SubCategory[]): void {
        const subCategorySelect = document.getElementById('subcateg') as HTMLSelectElement;
        if (!subCategorySelect) return;

        // Recupera le sotto-categorie salvate dal sessionStorage
        const savedSubCategoriesJson = sessionStorage.getItem('selectedSubCategories');
        let savedSubCategories: string[] = [];

        if (savedSubCategoriesJson && savedSubCategoriesJson !== 'null' && savedSubCategoriesJson !== '[]') {
            try {
                // Prova a parsare come array JSON
                savedSubCategories = JSON.parse(savedSubCategoriesJson);
                if (!Array.isArray(savedSubCategories)) {
                    // Se non è un array, trattalo come singolo valore
                    savedSubCategories = [savedSubCategoriesJson];
                }
            } catch {
                // Se il parse fallisce, trattalo come singolo valore
                savedSubCategories = [savedSubCategoriesJson];
            }
        }

        subCategorySelect.innerHTML = '';

        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = 'Seleziona una tipologia';
        subCategorySelect.appendChild(placeholderOption);

        subCategories.forEach(subCategory => {
            const option = document.createElement('option');
            option.value = subCategory.Id.toString();
            option.textContent = subCategory.Text;
            subCategorySelect.appendChild(option);
        });

        // Se c'è un solo elemento nelle sotto-categorie salvate, selezionalo
        if (savedSubCategories.length === 1) {
            const savedId = savedSubCategories[0];
            // Verifica che l'ID esista nelle opzioni disponibili
            const optionExists = subCategories.some(sc => sc.Id.toString() === savedId);
            if (optionExists) {
                subCategorySelect.value = savedId;
            } else {
                subCategorySelect.value = '';
            }
        }
        // Se c'è un solo elemento ricevuto dall'API, selezionalo automaticamente
        else if (subCategories.length === 1) {
            subCategorySelect.value = subCategories[0].Id.toString();
            sessionStorage.setItem('selectedSubCategories', subCategories[0].Id.toString());
        }
        // Altrimenti cerca di ripristinare il primo valore salvato (se ce n'è più di uno)
        else if (savedSubCategories.length > 0) {
            const savedId = savedSubCategories[0];
            const optionExists = subCategories.some(sc => sc.Id.toString() === savedId);
            if (optionExists) {
                subCategorySelect.value = savedId;
            } else {
                subCategorySelect.value = '';
            }
        } else {
            subCategorySelect.value = '';
        }
    }

    private convertStringToDecimal(str: string): number {
        str = str.replace('€', '').trim();
        str = str.replace(/\./g, '');
        str = str.replace(',', '.');
        return parseFloat(str) || 0;
    }

    private convertSurfaceToInteger(str: string): number {
        str = str.replace(/mq|m²/g, '').trim();
        return parseInt(str, 10) || 0;
    }
}
